import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import manageCustomers from '../../assets/img/manageCustomers.png';
import brands from '../../assets/img/brands.png';
import lists from '../../assets/img/lists.png';
import config from '../../assets/img/config.png';
import "react-confirm-alert/src/react-confirm-alert.css";
import { AiFillExclamationCircle, AiFillCheckCircle } from 'react-icons/ai';
import { FaEllo } from 'react-icons/fa';
import {
  Col,
} from "react-bootstrap";
import newOrder from '../../assets/img/newOrder.png';
import inProgress from '../../assets/img/inProgress.png';
import shipped from '../../assets/img/shipped.png';
import { createOrderActions } from "../../redux/actions/create-order-actions";
import { dataSyncActions } from "../../redux/actions/data-sync-actions";

class DashboardSuperAdminPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")).result.user,
      orderStates: {
        new_orders: '',
        in_progress_orders: '',
        shipped_last_week: '',
      },
      errorStates: [
        {
          "brand_name": '',
          "total_times_synced": '',
          "successful_syncs": '',
          "processing": '',
          "synced_with_errors": '',
          "last_sync_status": '',
          "last_sync_time": ''
        },
      ],
    };
  }


  async componentDidMount() {
    try {
      this.props.getErrorStatesCall();
      const res = await this.props.getOrderStatesCall();
      if (res.status !== true) {
      }
      this.setState({
        orderStates: res.result
      })
    } catch (e) {
      console.log(e)
    }
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.errorStates !== prevProps.errorStates && this.props.errorStates !== undefined) {
      const { errorStates } = this.props;
      this.setState({
        errorStates: errorStates
      })
    }
  }

  brandProcessingStatus(status) {
    switch (status) {
      case 'processed':
        return <span className="syncSuccess">
          <AiFillCheckCircle />
        </span>;
      case 'processed_with_errors':
        return <span className="syncWarning">
          <AiFillExclamationCircle />
        </span>
      case 'processing':
        return <span className="syncProcess">
          <FaEllo className="statusSpinner" />
        </span>
      default:
        return <span></span>
    }
  }

  render() {
    return (
      <React.Fragment>
        <Col md={12}>
          <h3 style={{ textAlign: 'left', fontWeight: "500" }}>
            Manage
          </h3>
        </Col>
        <div className="col-md-3">
          <Link to='/Admin/customers' className="resetLink block">
            <div className="dashboardAction">
              <div className="actionIcon">
                <img src={manageCustomers} alt="Manage Customers" />
              </div>
              <div className="actionLink">Customers</div>
            </div>
          </Link>
        </div>

        <div className="col-md-3">
          <Link to="/Admin/brands-list" className="resetLink block">
            <div className="dashboardAction">
              <div className="actionIcon">
                <img src={brands} alt="Brands" />
              </div>
              <div className="actionLink"> Brands</div>
            </div>
          </Link>
        </div>
        <div className="col-md-3">
          <Link to="/Admin/manage-lists" className="resetLink block">
            <div className="dashboardAction">
              <div className="actionIcon">
                <img src={lists} alt="Lists" />
              </div>
              <div className="actionLink">Lists</div>
            </div>
          </Link>
        </div>
        <div className="col-md-3">
          <Link to="/Admin/configuration-settings" className="resetLink block">
            <div className="dashboardAction">
              <div className="actionIcon">
                <img src={config} alt="Configuration" />
              </div>
              <div className="actionLink">Configuration</div>
            </div>
          </Link>
        </div>

        {/*  */}

        <Col md={12}>
          <h3 style={{ textAlign: 'left', fontWeight: "500", marginTop: '40px' }}>
            Sales Stats
          </h3>
        </Col>

        <Col md={4}>
          <Link to='/Admin/order-list' className="resetLink" style={{ width: '100%' }}>
            <div className="salesStats">
              <div className="statLabel">
                New Order
              </div>

              <div className="flexElem spaceBetween">
                <div className="statVal">
                  {this.state.orderStates.new_orders}
                </div>
                <div className="statIcon">
                  <img src={newOrder} alt="New orders" />
                </div>
              </div>
            </div>
          </Link>
        </Col>
        <Col md={4}>
          <Link to='/Admin/order-list' className="resetLink" style={{ width: '100%' }}>
            <div className="salesStats">
              <div className="statLabel">
                In Progress
              </div>

              <div className="flexElem spaceBetween">
                <div className="statVal">
                  {this.state.orderStates.in_progress_orders}
                </div>
                <div className="statIcon">
                  <img src={inProgress} alt="New orders" />
                </div>
              </div>
            </div>
          </Link>
        </Col>
        <Col md={4}>
          <Link to='/Admin/order-list' className="resetLink" style={{ width: '100%' }}>
            <div className="salesStats">
              <div className="statLabel">
                Shipped Last Week
              </div>

              <div className="flexElem spaceBetween">
                <div className="statVal">
                  {this.state.orderStates.shipped_last_week}
                </div>
                <div className="statIcon">
                  <img src={shipped} alt="New orders" />
                </div>
              </div>
            </div>
          </Link>
        </Col>

        <Col md={12}>
          <h3 style={{ textAlign: 'left', fontWeight: "500", marginTop: '40px' }}>
            Sync Status
                                                </h3>
        </Col>

        <Col md={12} className="mb-lg">
          <div className="gridElem grid_4 syncStatusContainer">
            {
              this.state.errorStates.map((data, index) => {
                return (
                  <div key={index}>
                    <div className="flexElem spaceBetween">
                      <div className="syncBrand">
                        {
                          data.synced_with_errors > 0
                            ?
                            <Link to={{ pathname: `/Admin/brands/syncErrors/${data.id}`, state: { brand_id: data.id } }}>{data.brand_name}</Link>
                            :
                            data.brand_name
                        }
                      </div>
                      <div className="syncStatus">
                        {
                          this.brandProcessingStatus(data.last_sync_status)

                        }
                      </div>
                    </div>
                    <div className="flexElem spaceBetween">
                      <div className="syncBrand">
                        Sync Count:
                        </div>
                      <div className="">
                        {data.total_times_synced}
                      </div>
                    </div>
                    <div className="flexElem spaceBetween">
                      <div className="syncBrand">
                        Successful:
                        </div>
                      <div className="">
                        {data.successful_syncs}
                      </div>
                    </div>
                    <div className="flexElem spaceBetween">
                      <div className="syncBrand">
                        Processing:
                        </div>
                      <div className="">
                        {data.processing}
                      </div>
                    </div>
                    <div className="flexElem spaceBetween">
                      <div className="syncBrand">
                        Failed:
                        </div>
                      <div className="">
                        {data.synced_with_errors}
                      </div>
                    </div>
                    <div className="flexElem spaceBetween">
                      <div className="syncBrand">
                        Last Synced:
                        </div>
                      <div className="">
                        {data.last_sync_time}
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </Col>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return ({
    getOrderStatesCall: () => { return dispatch(createOrderActions.getOrderStates()) },
    getErrorStatesCall: () => { return dispatch(dataSyncActions.getErrorStates()) },
  });
};

function mapStateToProps(state) {
  const { errorStates } = state.dataSyncReducer
  return {
    errorStates
  };
}


export default connect(mapStateToProps,
  mapDispatchToProps)(DashboardSuperAdminPage);



// WEBPACK FOOTER //
// ./src/components/Admin/DashboardSuperAdmin.jsx